import Loader from './src/loader'

export {
  Loader
}

export default {
  options: {},
  install(Vue) {
    Vue.prototype.showLoading = () => Loader.show()
    Vue.prototype.hideLoading = () => Loader.hide()
  }
}



// WEBPACK FOOTER //
// ./src/packages/components/loader/index.js